import { useSearchParams } from 'react-router-dom'

function useComesAuthenticatedFromAccounts() {
  const [searchParams] = useSearchParams()
  const wasLoginSuccess = searchParams.get('login') === 'success'
  return wasLoginSuccess
}

export default useComesAuthenticatedFromAccounts
